import { useGet } from "../../hooks/useGet";
import { NftsOverview, Spinner } from "../../components";
import React from "react";
import "./index.scss";
export var NftsOverviewMinted = function NftsOverviewMinted() {
  var _useGet = useGet("/nfts/minted"),
      data = _useGet.data;

  return (data === null || data === void 0 ? void 0 : data.nfts) ? /*#__PURE__*/React.createElement(NftsOverview, {
    nfts: data.nfts,
    lazy: false,
    title: "Sold NFTs"
  }) : /*#__PURE__*/React.createElement(Spinner, null);
};